import { ControlledTextField } from "../../../Core/Form/ControlledFields";
import { useFormContext } from 'react-hook-form';
import React, { useEffect } from "react"
import { Grid, MenuItem, Typography } from "@material-ui/core"
import FlexView from "react-flexview";
import { STATES } from "../../../../Constants";

const AirportAuthorityTextArea = () => {
    const { watch, getValues } = useFormContext();
    const shouldShow = watch("add_airport_authority");
    return (shouldShow ?
        <Grid container spacing={4} alignItems="center" className="margin-bottom-large">
                <Grid item xs={12}>
                <Typography variant="h4" className="gray">
                Governmental airport authority name
                </Typography>
                <ControlledTextField
                    fullWidth={true}
                    name="airport_authority_name"
                    className="margin-top-8"
                    placeholder="Governmental airport authority name"
                />
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h4" className="gray">
                Address Line 1
                </Typography>
                <ControlledTextField
                    fullWidth={true}
                    name="airport_authority_address1"
                    className="margin-top-8"
                    placeholder="Address Line 1"
                />
            </Grid>           
            <Grid item xs={12}>
            <Typography variant="h4" className="gray">
                Address Line 2 (optional)
                </Typography>
                <ControlledTextField
                    fullWidth={true}
                    name="airport_authority_address2"
                    className="margin-top-8"
                    placeholder="Address Line 2"
                />
            </Grid>
            <Grid item xs={4} md={4}>
                <Typography variant="h4" className="gray">
                City
                </Typography>
                <ControlledTextField
                    fullWidth={true}
                    name="airport_authority_city"
                    className="margin-top-8"
                    placeholder="City"
                />
            </Grid> <Grid item xs={4} md={4}>
                <Typography variant="h4" className="gray">
                    State
                </Typography>
                <ControlledTextField
                    select
                    fullWidth={true}
                    name="airport_authority_state"
                    className="margin-top-8"
                    placeholder="State"
                >
                    <MenuItem selected value="default" className="gray">
                        <span className="placeholder-gray">State</span>
                    </MenuItem>
                    {Object.keys(STATES).map((name) => (
                        <MenuItem key={name} value={name}>
                            {STATES[name]}
                        </MenuItem>
                    ))}
                </ControlledTextField>
            </Grid>
            <Grid item xs={4} md={4}>
                <Typography variant="h4" className="gray">
                Zip code
                </Typography>
                <ControlledTextField
                    fullWidth={true}
                    name="airport_authority_zipcode"
                    className="margin-top-8"
                    placeholder="Zip code"
                />    
             </Grid>
        </Grid> : <div/>
    )
}

export default AirportAuthorityTextArea;